import { render, staticRenderFns } from "./detailFilters.vue?vue&type=template&id=4303bd5b"
import script from "./detailFilters.vue?vue&type=script&lang=js"
export * from "./detailFilters.vue?vue&type=script&lang=js"
import style0 from "./detailFilters.vue?vue&type=style&index=0&id=4303bd5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports